import { styled } from '@mui/system';
import { ReactNode, useState } from 'react';

export type ViewerProps = {
  slides: ReactNode[];
  onActivate: (index: number) => void;
};

const StyledViewer = styled('div')(({ theme }) => ({
  position: 'relative',
  height: '100%',
  maxHeight: '300px',
  width: '100%',
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
}));

const getTransformOrigin = (index: number, count: number) => {
  if (count === 1) return '50% 50%';

  if (count === 2) {
    if (index === 0) return '0 50%';

    return '100% 50%';
  }

  switch (index) {
    case 0:
      return '0 50%';
    case 1:
      return '50% 50%';
    case 2:
      return '100% 50%';
  }
};

const Slide = styled('div')<{ active: boolean; index: number; count: number }>(
  ({ theme, index, active, count }) => ({
    position: active ? 'relative' : 'relative',
    transform: active ? 'scale(1.2)' : 'scale(1)',
    transformOrigin: getTransformOrigin(index, count),
    height: '100%',
    zIndex: active ? 1 : 0,
    cursor: 'pointer',
    transition: '.3s all',
    flex: '0 0 auto',
    maxWidth: `${(100 - 10) / count}%`,
  })
);

export const Viewer = ({ slides, onActivate }: ViewerProps) => {
  const [active, setActive] = useState(0);

  const activateSlide = (index: number) => {
    setActive(index);
    onActivate(index);
  };

  return (
    <StyledViewer>
      {slides.map((slide, index) => (
        <Slide
          key={index}
          index={index}
          active={index === active}
          count={slides.length}
          onClick={() => activateSlide(index)}
        >
          {slide}
        </Slide>
      ))}
    </StyledViewer>
  );
};
